import _ from 'lodash'
import { removeClass, addClass } from './dom'

export const updateBodyClass = (choices, value) => {
    if (choices.length > 0) {
        choices.forEach((other) => {
            removeClass('body', other)
        })
    }
    if (_.isArray(value)) {
        _.forEach(value, (val) => {
            addClass('body', val)
        })
    } else {
        addClass('body', value)
    }
}

export const updateThemeScheme = (value) => {
    let className = []
    if (value === 'auto') {
        className.push('auto')
        if (matchMedia('(prefers-color-scheme: light)').matches) {
            className.push('light')
        } else {
            className.push('dark')
        }
    } else {
        className.push(value)
    }
    updateBodyClass(['light', 'dark', 'auto'], className)
}

export const getPhoneFormInputStyle = (theme, validated, isValid) => {
    const styles = {
        dark: {
            '--react-international-phone-border-radius': '0.125rem',
            '--react-international-phone-border-color': validated
                ? isValid
                    ? '#1AA053'
                    : '#C03221'
                : 'rgba(255, 255, 255, 0.1)',
            '--react-international-phone-background-color': 'transparent',
            '--react-international-phone-text-color': '#ffffff',
            '--react-international-phone-selected-dropdown-item-background-color': '#17273c',
            '--react-international-phone-height': '40px',
            '--react-international-phone-font-size': '0.875rem',
        },
        light: {
            '--react-international-phone-border-radius': '0.125rem',
            '--react-international-phone-border-color': validated ? (isValid ? '#1AA053' : '#C03221') : '#EEEEEE',
            '--react-international-phone-background-color': 'transparent',
            '--react-international-phone-text-color': '#2a3749',
            '--react-international-phone-selected-dropdown-item-background-color': '#F9F9F9',
            '--react-international-phone-height': '40px',
            '--react-international-phone-font-size': '0.875rem',
        },
    }

    return theme === 'auto'
        ? styles[matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark']
        : styles[theme]
}
